
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 14A6 6 0 108 2a6 6 0 000 12z","stroke":"#ABAFB5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8 12a.75.75 0 100-1.5.75.75 0 000 1.5z","fill":"#ABAFB5"}}),_c('path',{attrs:{"d":"M8 9v-.5a1.75 1.75 0 10-1.75-1.75","stroke":"#ABAFB5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    